module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: "inbox",
    staticClass: "inbox"
  }, [_c('div', {
    staticClass: "inbox__wrapper"
  }, [_c('div', {
    staticClass: "inbox__header mt mb2"
  }, [_c('h1', {
    staticClass: "h1 group__title m0",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v(_vm._s(_vm.heading[_vm.stage]))])]), _vm._v(" "), _c('div', {
    staticClass: "inbox-grid inbox-grid__heading mb"
  }, _vm._l((_vm.inboxHeadings), function(heading, key) {
    return _c('p', {
      key: key,
      staticClass: "p small fw-bold c-accent",
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      })
    }, [_vm._v(_vm._s(heading))])
  }), 0), _vm._v(" "), _vm._l((_vm.stage === 'inbox' ? _vm.getInbox : _vm.getOutbox), function(message, key) {
    return _c('div', {
      key: key,
      staticClass: "inbox-grid cp",
      on: {
        "click": function($event) {
          return _vm.openMessage(message)
        }
      }
    }, _vm._l((_vm.inboxColumns), function(column, key) {
      return _c('div', {
        key: key,
        class: ['inbox-grid__column', ("inbox-grid__column--" + column)]
      }, [_c('p', {
        class: ['p', {
          'fw-bold': message.unread_status && _vm.stage === 'inbox'
        }]
      }, [_vm._v(" " + _vm._s(message[column]) + " ")])])
    }), 0)
  }), _vm._v(" "), _c('div', {
    staticClass: "pagination mt"
  }, [(_vm.getPrevious || _vm.getNext === "page=3") ? _c('span', {
    staticClass: "pagination__prev c-accent fw-bold cp",
    on: {
      "click": function($event) {
        return _vm.getPaginated('previous')
      }
    }
  }, [_c('module-icon', {
    staticClass: "mt-tiny",
    attrs: {
      "icon": "arrow-prev"
    }
  }), _vm._v("Newer")], 1) : _vm._e(), _vm._v(" "), (_vm.getNext) ? _c('span', {
    staticClass: "pagination__next c-accent fw-bold cp",
    on: {
      "click": function($event) {
        return _vm.getPaginated('next')
      }
    }
  }, [_vm._v("Older"), _c('module-icon', {
    staticClass: "mt-tiny ml-tiny",
    attrs: {
      "icon": "arrow-next"
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.stage === "inbox" ? _vm.getInbox && _vm.getInbox.length === 0 : _vm.getOutbox && _vm.getOutbox.length === 0) ? _c('p', [_vm._v("You have no " + _vm._s(_vm.stage === "inbox" ? "received" : "sent") + " messages")]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68376dbf"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/Inbox.vue
// module id = 512
// module chunks = 0